/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { Injectable } from '@angular/core';
import { BehaviorSubject, merge, Observable, Subject, takeUntil } from 'rxjs';

// - appState to inject the root userIdData and push it's data into it
// - userIdData now has no dependencies and can safely be injected anywhere
// - userIdData can have arbitrary data anywhere by providing a more specific version

// BEGIN PLACEHOLDER REPLACE AS PART OF TP-6383
// - need to further refine and standardize the concept

@Injectable({ providedIn: 'root' })
export class UserIdTpData<T> {
	private _userIdSubject = new BehaviorSubject<T>(null);
	private clearSubscriptions$ = new Subject<void>();

	/** the currently authenticated user's id */
	public userId$ = this._userIdSubject.asObservable();
	/** only for angularjs, _glare_ */
	public get userIdSync() {
		return this._userIdSubject.value;
	}

	/**
	 * register an observable to drive the data. Ideally this observable should
	 * clean up after itself and complete on it's own
	 */
	public registerDataSource(dataSource: Observable<T>): void {
		// doing this very low level, mostly to avoid completion forwarding
		// but also it's likely we might even want to suppress errors
		dataSource.pipe(takeUntil(this.clearSubscriptions$)).subscribe((data) => ({
			next: this._userIdSubject.next(data),
			error: (error) => this._userIdSubject.error(error),
		}));
	}

	/** clear out all data sources */
	public halt() {
		this.clearSubscriptions$.next();
	}
}
// END PLACEHOLDER REPLACE AS PART OF TP-6383
